import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

export const Root = styled(Box)({
    '& .head': {
        marginBottom: '17px',
    },
    '& .subtitle': {
        color: '#9B9B9B',
        fontSize: '12px',
    },
    '& .title': {
        color: '#005E96',
        fontSize: '16px',
    },
    '& .crtTitle': {
        color: '#005E96',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    '& .title2': {
        fontSize: '24px',
        fontWeight: 'bold',
        marginTop: '20px',
        marginBottom: '10px',
    },
    '& .table': {
        width: '100%',
        borderCollapse: 'collapse',
        border: '1px solid #D8D8D8',
        '& th': {
            height: '70px',
            backgroundColor: '#EDEDED',
            border: '1px solid #D8D8D8'
        },
        '& td': {
            height: '70px',
            backgroundColor: '#FDFBFE',
            border: '1px solid #D8D8D8'
        },
        '& .noBorder': {
            border: 'none',
        },
        '& .final': {
            backgroundColor: '#E3EFF7',
            color: '#142D33',
            fontWeight: 'bold',
        },
        '& .finalReport': {
            fontSize: '24px',
        },
        '& .addBtn': {
            verticalAlign: 'top',
        },
        '& .bgTransparent': {
            backgroundColor: 'transparent',
        },
        '& Button': {
            backgroundColor: '#fff',
        },
    },
    '& .del': {
        color: '#9B9B9B',
        cursor: 'pointer',
    },
    '& .infoBody': {
        padding: '0 50px',
    },
    '& .stateBar': {
        width: '100%',
        height: '6px',
    },
    '& .stateBall': {
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        marginRight: '10px',
    },
    '& .colorGreen': {
        backgroundColor: '#43D79E',
    },
    '& .colorBlue': {
        backgroundColor: '#18C6FF',
    },
    '& .colorGray': {
        backgroundColor: '#C1C0C2',
    },
    '& .colorYellow': {
        backgroundColor: '#fcba03',
    },
    '& .invoiceWapper': {
        width: '100%',
        padding: '24px',
        backgroundColor: '#fff',
        '& .pageTitle': {
            fontSize: '16px',
            fontWeight: 'bold',
            color: '#005E96',
        },
        '& .line': {
            width: '100%',
            height: '1px',
            backgroundColor: '#F3F3F3',
            margin: '20px 0',
        },
        '& .foot': {
            margin: '10px 0',
            '& .btn': {
                marginRight: '20px',
            },
        },
        '& .textWapper': {
            marginRight: '50px',
            '& .textTitle': {
                fontWeight: 'bold',
                fontSize: '14px',
                marginRight: '20px',
            },
            '& .textField': {
                width: '220px',
                height: '40px',
            },
            '& .status': {
                width: '220px',
                height: '40px',
                // border: '1px solid rgba(0, 0, 0, 0.28)',
                borderRadius: '4px',
                padding: '18.5px 14px 18.5px 0',
                marginTop: '8px',
                marginBottom: '4px',
            },
            '& .btn': {
                marginTop: '8px',
                marginBottom: '4px',
                width: '220px',
                height: '40px',
            },
            '& .w200': {
                width: '155px',
            },
        },

        '& .info-r': {
            width: '25%',
            '& .btn': {
                width: '100%',
            },
            '& .detailed': {
                marginTop: '76px',
                fontWeight: 'bold',
                fontSize: '16px',
                '& .line2': {
                    width: '100%',
                    height: '4px',
                    backgroundColor: '#D8D8D8',
                    margin: '20px 0',
                },
                '& .total': {
                    fontSize: '28px',
                },
            },
        },
        '& .mr-10': {
            marginRight: '10px',
        },
        '& .mt-10': {
            marginTop: '10px',
        },
    },
});